<script lang="ts">
	import type { SvelteAsr, i18n } from 'types/common'
	import type { ChildStates } from './home'
	import type { HomeData$result } from '$houdini'

	import { AsrNavTabBar } from '@isoftdata/svelte-nav-tab-bar'
	import { hasPermission } from 'utility/permission'
	import Card from '@isoftdata/svelte-card'
	import Icon from '@isoftdata/svelte-icon'
	import { getContext } from 'svelte'

	interface Props {
		asr: SvelteAsr
		childStates: ChildStates
		stores: HomeData$result['stores']
		users: HomeData$result['userAccounts']
	}

	let { asr, childStates }: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')

	let displayChildStates = $derived(childStates.filter(state => hasPermission(state.requiredPermission)))
</script>

<Card bodyClass="p-2">
	{#snippet header()}
		<div>
			<p class="h4">
				<Icon
					fixedWidth
					icon="home"
					class="me-1"
				/>{translate('common:home', 'Home')}
			</p>
			<iframe
				class="home-iframe"
				src="https://getitrack.com/itrack-enterprise-web-home-screen/"
				title="Enterprise Web Home Screen"
			></iframe>

			<AsrNavTabBar
				{asr}
				breakpoint="md"
				tabs={displayChildStates}
			/>
		</div>
	{/snippet}
	<uiView></uiView>
</Card>

<style>
	.home-iframe {
		width: 100%;
		border-style: solid;
		height: 35vh;
		max-height: 250px;
		border-color: var(--bs-border-color);
		margin-bottom: 15px;
		display: inline;
	}
</style>
